import { useSelector } from 'react-redux';

export default function useRegion() {
  return useSelector((state) => state.intl.region);
}
